export default "__VITE_ASSET__CSIyMzO8__"